import {
  createLoggingAnalyticsPort,
  type AnalyticsPort,
} from "@dawn/adapters";
import { captureGameplayEventRaw } from "@/analytics/captureGameplayEvent";

/**
 * Production analytics sink: PostHog (when initialized) + DEV console via gameLogger.
 */
export function createGameplayAnalyticsPort(): AnalyticsPort {
  const logging = createLoggingAnalyticsPort();

  return {
    emit(eventName, properties, context) {
      captureGameplayEventRaw(eventName, properties);
      logging.emit(eventName, properties, context);
    },
  };
}
